import type { DurationInMinutes } from "@@/shared/date-time/time-spans";
import type { OrderGroupId } from "@@/shared/order-groups/order-group-id";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { z } from "zod";
import type { OrderId } from "../order-id";
import {
    _orderStatusBaseFactory,
    _orderStatusBaseZodSchema,
} from "./_order-status-base";
import { orderStatusType } from "./order-status-types";

const orderStatusConfirmedZodSchema = _orderStatusBaseZodSchema.merge(
    z.object({
        type: z.literal("CONFIRMED"),
        prepTime: z
            .number()
            .min(10) as unknown as z.ZodSchema<DurationInMinutes>,
        confirmedBy: userIdZodSchema.optional(),
    }),
);
type OrderConfirmed = z.infer<typeof orderStatusConfirmedZodSchema>;

const orderStatusConfirmedFactory = (params: {
    readonly orderId: OrderId;
    readonly orderGroupId: OrderGroupId;
    readonly prepTime: DurationInMinutes;
    readonly confirmedBy: UserId | undefined;
}): OrderConfirmed => ({
    ..._orderStatusBaseFactory(params.orderId, params.orderGroupId),
    type: orderStatusType.CONFIRMED,
    prepTime: params.prepTime,
    confirmedBy: params.confirmedBy,
});

export { orderStatusConfirmedFactory, orderStatusConfirmedZodSchema };
export type { OrderConfirmed };
